import { sva } from '@agapi/ui/panda/css';

export const campaignCardStyles = sva({
  slots: ['root', 'image', 'header', 'heading', 'container', 'content', 'description', 'footer', 'badge', 'link'],
  base: {
    root: {
      position: 'relative',
      p: 0,
      justifyContent: 'flex-end',
      overflow: 'visible!',
    },
    link: {
      textDecoration: 'none',
      height: '100%',
      display: 'flex',
      flexDir: 'column',
      justifyContent: 'flex-end',
    },
    image: {
      borderRadius: 'surface.sm',
      mx: 'auto',
      py: '5',
      px: '5',
      mb: 'auto',
    },
    container: {
      display: 'flex',
      flexDir: 'column',
      zIndex: 1,
      maxW: 'container.tight',
      width: '90%',
      left: 0,
      bottom: 0,
    },
    content: {
      py: '2!',
      flex: 0,
    },
    header: {
      zIndex: 1,
      gap: '3'
    },
    heading: {
      textStyle: 'h3',
    },
    description: {
      fontWeight: '500',
      fontSize: 'lg'
    },
    badge: {
      right: '-3',
      top: '-3',
      position: 'absolute',
      zIndex: 1,
      pointerEvents: 'none',
    },
  },
  variants: {
    size: {
      lg: {
        root: {
          flexShrink: 0,
          flexGrow: 2,
          maxHeight: '60dvh',
          maxWidth: 'calc(100vw - (token(spacing.app) * 2))',
        },
        image: {
          objectFit: 'contain',
        },
      },
      md: {
        root: {
          flexBasis: {
            base: '10',
            md: '11',
          },
//          flexShrink: 0,
          flexGrow: 2,
          minWidth: 'containers.xs',
          md: {
            maxWidth: '66%',
          }
        },
        image: {
          height: 'containers.sm',
          mx: 'auto',
          ml: 'auto',
          float: 'right',
          width: 'auto',
        },
      },
      sm: {
        root: {
          flexBasis: {
            base: '10',
          },
          minWidth: 'containers.xs',
          flexShrink: 1,
          flexGrow: 1,
        },
        image: {
          height: 'containers.xs',
          mx: 'auto',
          width: 'auto',
        },
      },
    },
  },
});